import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";

const CategoryDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const CategoryDictionary = createCustomReadonlyDictionary({
  itemModel: CategoryDictionaryItem,
  fetch: async function() {
    return await api.get(`/workout/category/slim-list`);
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default CategoryDictionary.create();
